import { useState } from 'react';

import { gql, useQuery } from '@apollo/client';

export const GET_PROCESS_TASKS_TEMPLATES_FOR_TABLE = gql`
  query getProcessTaskTemplates($queryOptions: QueryOptionsInput!) {
    getProcessTaskTemplates(queryOptions: $queryOptions) {
      collection {
        _id
        name
        createdBy
      }
      totalCount
    }
  }
`;

export const useGetProcessTasksTemplatesForTable = () => {
  const [currentPage, setPage] = useState(1);
  const pageSize = 12;
  const { data, loading } = useQuery(GET_PROCESS_TASKS_TEMPLATES_FOR_TABLE, {
    variables: {
      queryOptions: { limit: pageSize, skip: pageSize * currentPage - pageSize },
    },
    fetchPolicy: 'no-cache',
  });

  const { totalCount = 0, collection = [] } = data?.getProcessTaskTemplates || {};

  return {
    loading,
    collection,
    paginationConfig: {
      total: totalCount,
      pageSize,
      current: currentPage,
      onChange: (page: number) => setPage(page),
    },
  };
};

export const useGetAllProcessTemplateForList = () => {
  const { data, loading } = useQuery(GET_PROCESS_TASKS_TEMPLATES_FOR_TABLE, {
    variables: {
      queryOptions: {},
    },
    fetchPolicy: 'network-only',
  });

  const { totalCount = 0, collection = [] } = data?.getProcessTaskTemplates || {};

  return { loading, collection, totalCount };
};
